import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import GridFilterPanel from '../../commons/filters/GridFilterPanel.jsx';
import {
	PERIODO_ULTIMOS_7,
	PERIODO_ULTIMOS_14,
	PERIODO_ULTIMOS_30,
	buildPeriodoOptions,
} from '../../commons/filters/periodos.js';
import * as Utils from '../../commons/utils/Utils';
import {
	SOLICITUDES_FILTROS_STORAGE_KEY,
	buildSolicitudesFilterFields,
	getSolicitudesFilterDefaults,
} from './solicitudesFilterFields.js';
import { etiquetaLlavesEnVigilancia } from './solicitudEstado.js';

const OPTIONS_INIT = { estado: [], base: [], region: [], centroCostos: [], llavesEnVigilancia: [], periodo: [], turno: [] };

export const buildEstadoOptions = (intl) => [
	{ value: 'PENDIENTE', label: intl.formatMessage({ id: 'solicitudes.estado.pendiente', defaultMessage: 'PENDIENTE' }) },
	{ value: 'LIBERADA', label: intl.formatMessage({ id: 'solicitudes.estado.liberada', defaultMessage: 'LIBERADA' }) },
	{ value: 'RECHAZADA', label: intl.formatMessage({ id: 'solicitudes.estado.rechazada', defaultMessage: 'RECHAZADA' }) },
	{ value: 'CANCELADA', label: intl.formatMessage({ id: 'solicitudes.estado.cancelada', defaultMessage: 'CANCELADA' }) },
];

// Pedido del PO: en Solicitudes los períodos no ofrecen los "Últimos N días".
const ULTIMOS_N_DIAS = [PERIODO_ULTIMOS_7, PERIODO_ULTIMOS_14, PERIODO_ULTIMOS_30];
const buildPeriodosSolicitudes = (intl) => buildPeriodoOptions(intl).filter((o) => !ULTIMOS_N_DIAS.includes(o.id));

const buildLlavesEnVigilanciaOptions = (intl) => [
	{ value: '1', label: etiquetaLlavesEnVigilancia(intl, true) },
	{ value: '0', label: etiquetaLlavesEnVigilancia(intl, false) },
];

const SolicitudesGridFiltros = (props) => {
	const intl = useIntl();
	const [options, setOptions] = useState(OPTIONS_INIT);
	const [optionsLoading, setOptionsLoading] = useState(true);

	const fields = buildSolicitudesFilterFields(intl);

	const overrideState = () => {
		if (!props.overrideSignal) return null;
		const opcion = options.estado.find((o) => o.value === props.overrideSignal.estado);
		return { estado: opcion ? [opcion] : [], periodo: null };
	};

	useEffect(() => {
		setOptionsLoading(true);
		const fijas = { estado: buildEstadoOptions(intl), llavesEnVigilancia: buildLlavesEnVigilanciaOptions(intl), periodo: buildPeriodosSolicitudes(intl), turno: buildPeriodosSolicitudes(intl) };
		Promise.all([
			Utils.getData('/bases/select-filtered-by-user/base/'),
			Utils.getData('/regiones/select'),
			// Ya viene recortado a los centros de costos del usuario si tiene USUARIO_TRABAJAR_CC.
			Utils.getData('/centros-costos/select'),
		])
			.then((data) => setOptions(Object.assign({}, fijas, { base: data[0] || [], region: data[1] || [], centroCostos: data[2] || [] })))
			.catch(() => setOptions(Object.assign({}, OPTIONS_INIT, fijas)))
			.finally(() => setOptionsLoading(false));
	}, []);

	return (
		<GridFilterPanel
			open={props.open}
			fields={fields}
			options={options}
			defaults={getSolicitudesFilterDefaults(intl)}
			storageKey={SOLICITUDES_FILTROS_STORAGE_KEY}
			loading={props.loading || optionsLoading}
			applyOnMount={true}
			resetSignal={props.resetSignal}
			onResetSignalHandled={props.onResetSignalHandled}
			onApply={props.onApply}
			overrideState={overrideState()}
			overrideSignal={optionsLoading ? null : props.overrideSignal}
			onOverrideSignalHandled={props.onOverrideHandled}
		/>
	);
};

export default SolicitudesGridFiltros;
